import { useDispatch } from 'react-redux';
import { setDisable } from '../redux/disable';
import { setLoading } from '../redux/loading';
import { useHistory } from 'react-router-dom';
import Success from '../components/Snack/Success';
import Error from '../components/Snack/Error';
import { useState } from 'react';

export function useRequest(apiRequest, historyRoute) {
  const dispatch = useDispatch();
  const [openProgress, setOpenProgress] = useState(false);
  const history = useHistory();
  const error = Error();
  const success = Success();

  async function request(data) {
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));
    dispatch(setLoading(true));
    setOpenProgress(true);
    try {
      await apiRequest(data);
      setOpenProgress(false);
      success();
      history.push(historyRoute);
    } catch (err) {
      error(err.response.data.message);

      setOpenProgress(false);
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  return {
    request,
    openProgress,
  };
}
